/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class CustomerUse extends Component {
  state = {
    tabIndex: 0,
  };
  componentDidMount = () => {
    const { match } = this.props;
    console.log(match.params.index);
    this.setState({
      tabIndex: parseInt(match.params.index) === 4 ? 0 : 1,
    });
  };
  _changeTab = (tabIndex) => {
    this.setState({
      tabIndex,
    });
  };
  render() {
    const { tabIndex } = this.state;
    return (
      <Fragment>
        <div className="service_content">
          <h2>
            <a
              style={{ cursor: 'pointer' }}
              className={tabIndex === 0 ? 'on' : null}
              onClick={() => this._changeTab(0)}
            >
              이용약관
            </a>
            <a
              style={{ cursor: 'pointer' }}
              className={tabIndex === 1 ? 'on' : null}
              onClick={() => this._changeTab(1)}
            >
              개인정보 처리방침
            </a>
          </h2>
          {/* {tabIndex === 0 ? (
            <div className="terms_style">
              <p>제 1 조 (목적)</p>
              <p>
                본 약관은 주식회사 애니플러스(이하 “회사”라 한다.)가 제공하는
                애니플러스 사이트의 모든 서비스(이하 “서비스”)에 대한 이용 조건
                및 절차에 관한 기본적인 사항을 규정함을 목적으로 합니다.
              </p>
              <p>제 2 조 (약관의 효력 및 변경)</p>
              <p>
                본 약관은 애니플러스 사이트 (www.aniplustv.com) 에 게시하거나
                전자우편 등 기타의 방법으로 회원에게 통지함으로써 효력을
                발생시킵니다. 본 약관은 회사의 합리적인 사유가 발생하는 경우
                사전 고지 없이 변경될 수 있으며, 변경된 약관은 위와 동일한
                방법으로 공지함으로써 효력을 발생합니다. 회원은 변경된 약관에
                동의하지 않을 경우 서비스 이용을 중단하고 회원 탈퇴를 할 수
                있으며, 변경된 약관의 효력 발생일 이후의 계속적인 서비스 이용은
                약관의 변경 사항에 동의한 것으로 간주됩니다.
              </p>
              <p>제 3 조 (약관 외 준칙)</p>
              <p>
                본 약관에 명시되지 않은 사항에 대해서는 전기통신기본법,
                전기통신사업법, 전자상거래를 규정한 법률 및 기타 관련 법령의
                규정에 따르며, 개별 서비스에 대한 세부적인 사항은 해당 서비스의
                이용안내 및 공지에 따릅니다.
              </p>
            </div>
          ) : (
            <div className="terms_style">
              <p>
                '(주)애니플러스'는 (이하 '회사'는) 고객님의 개인정보를
                중요시하며, "정보통신망 이용촉진 및 정보보호"에 관한 법률을
                준수하고 있습니다. 회사는 개인정보취급방침을 통하여 고객님께서
                제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며,
                개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
                회사는 개인정보취급방침을 개정하는 경우 웹사이트 공지사항(또는
                개별공지)을 통하여 공지할 것입니다.
              </p>
              <p>1. 수집하는 개인정보 항목</p>
              <p>
                ① 수집항목 : 이름 , 닉네임, 생년월일, 아이디, 비밀번호, 이메일,
                전화번호, 휴대폰번호, 주소 , 서비스 이용기록 , 접속 로그 , 쿠키
                , 접속 IP 정보 , 결제기록 ② 개인정보 수집방법 :
                홈페이지(회원가입)
              </p>
              <p>2. 개인정보의 수집 및 이용 목적</p>
              <p>
                ① 회원 관리 회원제 서비스 이용에 따른 본인확인, 개인식별,
                불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인,
                가입 및 가입횟수 제한, 만14세 미만 아동 개인 정보 수집 시 법정
                대리인 동의여부 확인, 추후 법정 대리인 본인확인, 분쟁 조정을
                위한 기록보존, 불만처리 등 민원처리, 고지사항 전달 ② 마케팅 및
                광고에 활용발생하는 경우 사전 고지 없이 변경될 수 있으며, 변경된
                약관은 제 1 항과 같은 방법으로 공지함으로써 효력을 발생합니다.
                회원은 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고
                회원 탈퇴를 할 수 있으며, 변경된 약관의 효력 발생일 이후의
                계속적인 서비스 이용은 약관의 변경 사항에 동의한 것으로
                간주됩니다.
              </p>
              <p>제 3 조 (약관 외 준칙)</p>
              <p>
                본 약관에 명시되지 않은 사항에 대해서는 전기통신기본법,
                전기통신사업법, 전자상거래를 규정한 법률 및 기타 관련 법령의
                규정에 따르며, 개별 서비스에 대한 세부적인 사항은 해당 서비스의
                이용안내 및 공지에 따릅니다.
              </p>
            </div>
          )} */}

          <div style={{ height: 50 }}></div>
          {tabIndex === 0 ? (
            <>
              <h3>서비스 이용약관</h3>
              <div className="terms_style">
                <p>제 1 조 (목적)</p>
                <p>
                  본 약관은 주식회사 애니플러스(이하 “회사”)가 제공하는 콘텐츠와
                  재화 또는 용역(이하 “상품”)을 구입하는 경우(이하 “구매”)와
                  관련하여 회사와 이용자와의 권리, 의무 및 책임사항 등을
                  규정함을 목적으로 합니다.
                </p>
                <p>제 2 조 (용어의 정의)</p>
                <p>
                  이 약관에서 사용하는 용어의 정의는 다음과 같습니다. 1. 해지 :
                  회사 또는 회원이 서비스 개통 후 이용 계약을 해약하는 것을
                  말합니다. 2. 유료 서비스: 유료서비스라 함은 회원이 회사에 일정
                  금액을 지불해야만 이용할 수 있는 회사의 콘텐츠를 의미하거나,
                  회사 또는 제3자와의 거래 내지 약정 조건을 수락하는 대가로
                  이용하게 되는 회사의 콘텐츠를 의미합니다. 유료서비스의
                  세부내용은 각각의 서비스 페이지에 상세히 설명되어 있으며
                  안내된 내용을 바탕으로 이용 가능합니다. 3. 상품 : 상품이라
                  함은 회원이 회사에 일정 금액을 지불하고 공급 받는 재화 또는
                  용역을 의미합니다. 4. 결제: 회사가 제공하는 유료서비스 이용
                  또는 상품을 구입하기 위하여 각종 지불수단을 통하여 일정 금액을
                  회사 또는 회사가 정한 제3자에 지불 하는 것을 의미합니다. 5.
                  구매 : 회사가 유료서비스에 대한 이용 승낙 및 유료서비스 제공이
                  가능할 수 있도록 회원이 이용하고자 하는 유료서비스를 선택하여
                  해당 유료서비스의 가액과 동일한 적립금의 차감을 청구하거나
                  지불수단을 통한 결제로써 그 대가를 지급하는 행위를 의미합니다.
                  6. Live : 회사가 방송채널의 실시간 방송을 회원에게 제공하는
                  서비스를 말합니다. 7. 포인트 : 회원의 직접 결제에 따른 충천,
                  상품 구매로 인한 적립, 환불 및 보상, 이벤트 수단으로
                  회사로부터 지급받는 사이머 머니(전자화폐)로서, 애니플러스의
                  유료서비스를 이용하기 위해 현금처럼 지불할 수 있는
                  유무선인터넷상의 지급 수단을 의미합니다.
                </p>
                <p>제 3 조 (유료 서비스 이용계약의 성립 등)</p>
                <p>
                  1. 회원은 회사가 제공하는 다음 또는 이와 유사한 절차에 의하여
                  이용신청을 합니다. 회사는 계약 체결 전에 각 호의 사항에 관하여
                  회원이 정확하게 이해하고 실수 또는 착오 없이 거래할 수 있도록
                  정보를 제공합니다. ① 유료서비스 확인 및 선택 ② 결제방법의 선택
                  및 결제정보의 입력 ③ 유료서비스의 이용신청에 관한 확인 또는
                  회사의 확인에 대한 동의 2. 회사는 회원의 이용신청이 다음 각
                  호에 해당하는 경우에는 승낙하지 않거나 승낙을 유보할 수
                  있습니다. ① 실명이 아니거나 타인의 명의를 이용한 경우 ② 허위의
                  정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우 ③
                  미성년자가 청소년보호법에 의해서 이용이 금지되는 콘텐츠를
                  이용하고자 하는 경우 ④ 서비스 관련 설비의 여유가 없거나,
                  기술상 또는 업무상 문제가 있는 경우 3. 이용계약의 성립시기는
                  가입완료, 구매완료를 신청절차 상에서 표시한 시점으로 합니다.
                  4. 회원이 유료서비스를 이용하기 위해서는 이 약관에 동의 후 각
                  서비스에 따른 이용조건에 따라 이용요금을 지급하여야 합니다.
                </p>
                <p>제 4 조 (유료서비스 및 범위)</p>
                <p>
                  1. 회사가 회원에게 제공하는 유료서비스의 종류는 아래와
                  같습니다. ① 서비스 속성에 따른 분류 (ㄱ) 스트리밍 서비스:
                  회사가 콘텐츠를 온라인 스트리밍 방식으로 제공하는 서비스 (ㄴ)
                  다운로드 서비스 : 회사가 콘텐츠를 다운로드 방식으로 제공하는
                  서비스 (ㄷ) Live 서비스 : 회사가 방송 채널, 또는 자체적으로
                  편성한 컨텐츠를 온라인 스트리밍 방식으로 제공하는 서비스. ②
                  자동결제 여부에 따른 분류 (ㄱ) 기간제 상품: 회원이 Live,
                  다시보기, 다운로드 서비스를 이용하고자 하는 기간 동안만 이용할
                  수 있는 상품 (ㄴ) 정기결제 상품: 서비스를 이용하는 회원이
                  정기적으로 유료서비스 이용 요금을 회사에 결제하기로 신청한
                  경우 회원이 지정한 결제 일자 및 수단으로 유료서비스의 이용
                  요금이 자동으로 결제되는 상품
                </p>
                <p>제 5 조 (상품에 대한 구매 서비스 이용)</p>
                <p>
                  1. 회사는 서비스 이용 중 발생하는 상품 구매에 대해 다음 각
                  호와 같은 업무를 수행 합니다. ① 회원에게 상품에 대한 정보 제공
                  및 구매계약의 체결 ② 구매계약이 체결된 상품의 배송업무 ③ 기타
                  회사가 정하는 업무 2. 회사는 이미 구매계약이 체결된 상품의
                  품절 또는 기술적 사양의 변경 등의 경우에는 이용자의 동의 하에
                  새로운 내용의 구매계약으로 변경할 수 있습니다. 이 경우에는
                  변경 된 상품의 내용 및 제공일자를 명시하여 현재의 상품의
                  내용을 게시한 곳에 즉시 공지하고, 이용자에게 통지 가능한
                  방법으로 즉시 통지합니다. 3. 회사는 회사가 제공하기로 이용자와
                  계약을 체결한 서비스의 내용을 상품 등의 품절 또는 기술적
                  사양의 변경 등의 사유로 부득이 해당 구매계약을 취소하여야 할
                  경우 그 사유와 내용을 이용자에게 통지 가능한 방법으로 즉시
                  통지하고, 해당 구매계약을 취소할 수 있습니다. 4. 전항의 경우
                  회사는 이용자로부터 해당 구매계약과 관련하여 이미 지급받은
                  금액이 있을 시에는 이를 즉시 전액 환불합니다. 구매계약의
                  취소가 회사의 고의 또는 중대한 과실로 인한 것이 아닌 경우
                  회사는 별도의 손해배상은 하지 않습니다.
                </p>
                <p>제 6 조 (결제방식)</p>
                <p>
                  1. 유료서비스의 이용과 상품구매에 대한 대금 지급 방법은 다음
                  각 호의 방법 중 가능한 방법으로 할 수 있습니다. ① 선불카드,
                  직불카드, 신용카드 등의 각종 카드결제 ② 휴대전화를 이용한 결제
                  ③ 인터넷뱅킹 등의 각종 계좌이체 ④ 회사와 계약을 맺었거나
                  회사가 인정한 상품권에 의한 결제 ⑤ 포인트 등 사이버 머니에
                  의한 결제
                </p>
                <p>제 7 조 (정기결제 및 해지)</p>
                <p>
                  1. 회사는 매월 서비스 이용계약의 자동갱신 및 이용요금 청구를
                  위해 유료서비스 이용기간 및 유료서비스 이용 기간 종료 후
                  일정기간 동안 회원의 결제관련정보를 보유할 수 있습니다. 2.
                  회원이 정기결제를 신청하시면 별도의 해지 신청을 하지 않을
                  경우, 유료서비스의 실제 이용 여부와 상관없이 매월 지정된 결제
                  일자 및 수단으로 자동 청구 및 결제됩니다. (최초 결제일 익일
                  1일차부터 서비스 일수로 계산) 3. 정기결제해지로 인한 만료일은
                  자동결제일로부터 1개월 입니다. 정기결제해지 시 회원은 정기
                  결제일로부터 1개월 동안 서비스를 이용할 수 있습니다. 4. 타인의
                  결제 정보를 동의 없이 사용할 경우 민/형사상 책임을 지게 되며
                  관계법령에 의해 처벌될 수 있습니다. 5. 결제 정보 변경,
                  신용카드 및 휴대전화의 분실, 기타의 사유로 정기결제가
                  이루어지지 않을 경우 마지막 정기결제일로부터 1개월 이 지난 후
                  서비스 이용이 자동 정지됩니다. 6. 회원의 이용요금 미납 등
                  귀책사유로 인한 정기결제중지 및 이에 따른 서비스 이용정지로
                  인한 손해에 대해 회사는 책임을 지지 않습니다.
                </p>
                <p>제 8 조 (회원의 유료서비스 청약철회와 결제취소)</p>
                <p>
                  1. 회사와 유료서비스의 이용에 관한 계약을 체결한 회원은
                  수신확인의 통지를 받은 날로부터 7일 이내에는 청약의 철회를 할
                  수 있습니다. 2. 제1항의 청약철회는 회원이 전화, 전자우편으로
                  회사에 그 의사를 표시한 때에 효력이 발생합니다. 3. 회사는
                  제1항에 따라 회원이 표시한 청약철회 의사표시를 수신한 후 지체
                  없이 이러한 사실을 회원에게 회신합니다. 4. 회원은 이용신청을
                  철회한 경우 회원이 선택한 각각의 결제방식에 따라 회사에 해당
                  결제취소처리를 신청할 수 있습니다. 다만, 각 호의 경우에는
                  결제취소처리가 불가능합니다. ① 이벤트, 쿠폰, 보상 등
                  결제수단이 무료로 지급된 경우 ② 해당 기간 내에 사용내역이
                  있거나 결제에 따른 추가 지급 혜택을 이용했을 경우 ③ 해당
                  결제수단에 따른 결제취소 가능기간을 경과한 경우 5.
                  결제취소처리가 불가능한 결제방식(계좌이체 등)을 이용해서
                  유료서비스를 결제한 경우, 이 경우는 본 약관 제 10 조에 따라
                  환불처리만 가능합니다. 6. 각각의 결제방식에 따른 결제취소
                  가능기간은 다음과 같으며, 결제취소 가능기간이 경과한 경우
                  결제취소처리가 불가능합니다. 단, 아래 각 호는 관련업체의
                  사정에 따라 변경될 수 있습니다. ① 신용카드 : 결제당일 ~
                  1개월(30일) 이내에 결제취소가 가능합니다. 단, 각각의 해당
                  신용카드사의 정책에 따라 취소가능기간이 다를 수 있습니다. ②
                  휴대전화 : 결제 당월 말일 하루 전까지 결제취소가 가능합니다.
                  단, 각각의 해당 이동통신업체의 정책에 따라 취소가능기간이 다를
                  수 있습니다. ③ 계좌이체 : 거래방식 특성상 결제취소가
                  불가능하여 결제대행 수수료 등을 공제한 환불처리만 가능합니다.
                  ④ 상품권 : 1개월(30일) 이내에 결제취소가 가능합니다. 단, 각
                  상품권 운영사의 정책에 따라 취소가능기간이 다를 수 있습니다.
                  또한 회원의 각 상품권사에 대한 회원 가입/탈퇴/사고 여부 등에
                  따라 결제취소가 불가능한 경우가 있습니다. 7. 멤버십 등의 유료
                  서비스의 청약 철회 및 결제 취소를 진행할 경우 취소일로부터
                  최소 30일간 재청약 및 유료 서비스 이용에 제약이 있을 수
                  있습니다.
                </p>
                <p>제 9 조 (회원의 유료 서비스 계약해제•해지)</p>
                <p>
                  1. 회사는 회원이 청약철회의 의사표시를 한 날로부터 또는
                  회원에게 계약해제•해지의 의사표시에 대하여 회신한 날로부터 14
                  영업일 이내에 대금의 결제와 동일한 방법으로 이를 환급하여야
                  하며, 동일한 방법으로 환불이 불가능할 때에는 이를 사전에
                  고지하여야 합니다. 2. 회사가 제1항에 따라 환급할 경우에 회원이
                  서비스 이용으로부터 얻은 이익에 해당하는 금액을 공제하고
                  환급할 수 있습니다. 3. 회사는 위 대금을 환급함에 있어서 회원이
                  신용카드 또는 전자화폐 등의 결제수단으로 상품 등의 대금을
                  지급한 때에는 지체 없이 당해 결제수단을 제공한 사업자로 하여금
                  상품 등의 대금의 청구를 정지 또는 취소하도록 요청합니다. 다만,
                  제2항의 금액공제가 필요한 경우에는 그러하지 아니할 수
                  있습니다. 4. 회사, “유료서비스 등의 대금을 지급 받은 자” 또는
                  “회원과 유료서비스 이용계약을 체결한 자“가 동일인이 아닌
                  경우에 각자는 청약철회 또는 계약해제•해지로 인한 대금환급과
                  관련한 의무의 이행에 있어서 연대하여 책임을 집니다.
                </p>
                <p>제 10조 (애니플러스 포인트 이용)</p>
                <p>
                  1. 회원은 `애니플러스 포인트`를 통해 회사가 제공하는 다음 각
                  호의 서비스를 이용할 수 있습니다. ① 애니플러스 온라인샵 쇼핑.
                  ② 애니플러스 오프라인 샵 쇼핑. ③ 홈페이지 기간제 멤버십 구매
                  및 VOD 건별 구매. ④ 홈페이지 상영회 예매. ⑤ 그 외 회사가
                  지정한 비정기 이벤트, 행사. 2. 회원은 다음 각 호와 같은
                  방식으로 포인트를 회사로부터 지급받을 수 있습니다. ①
                  홈페이지/모바일에서 회사가 지원하는 결제 방식에 따라 회원이
                  유상으로 충전. 10,000원 결제 (10,000포인트) / 30,000원 결제
                  (30,000포인트) / 100,000원 결제 (100,000포인트) ②
                  온라인샵/오프라인 샵에서 상품 구매를 통한 적립 ③ 회사가 발행한
                  쿠폰, 이벤트 당첨, 멤버십 회원 혜택을 통한 무상 지급. ④ 그외
                  회사가 지정한 비정기 이벤트, 행사를 통한 무상 지급 ⑤ 기존
                  보유하고 있던 캐시가 포인트로 전환된 경우. 3. 유상으로 충전한
                  포인트의 유효 기간은 지급 시점으로부터 1년입니다. 그 외
                  무상으로 지급된 포인트의 유효 기간은 지급 기준에 따라
                  1개월에서 1년까지 상이할 수 있습니다. 기존에 가지고 있던
                  캐시가 포인트로 전환된 경우, 유효 기간은 기존 캐시와 동일하게
                  적용됩니다.
                </p>
                <p>제 11조 (애니플러스 환불 규정)</p>
                <p>
                  1. 회원은 유상으로 충전한 포인트를 환불 및 결제 취소 할 수
                  있습니다. 환불 가능 대상은 각 호에 따릅니다. 환불 문의는
                  고객센터를 통해서만 가능합니다. ① 충전 이후 단 한 1건도
                  유상,무상으로 지급된 포인트 사용 내역이 없는 경우. (결제 취소)
                  ② 해당 회원의 유상 충전 금액 총합이 60% 이상 사용된 경우.
                  (환불) 2. 1항에 해당되더라도 각 호의 경우 환불 및 결제취소가
                  불가합니다. ① 11조 2항에 해당되지 않는 회사가 규정하지 않은
                  방식, 합법적이지 않은 수단으로 포인트를 충전하거나 이용한
                  경우. ② 유상으로 충전한 회원 계정 정보와 환불 회원 정보가
                  일치하지 않는 경우. ③ 일부 금액만을 부분 환불하려는 경우. 3.
                  환불/결제 취소 접수 후 유상 충전으로 인한 추가 지급 포인트는
                  소멸되며, 이미 사용했을 경우 해당 금액 만큼 차감 후,
                  환불수수료 10%가 추가 제외된 금액으로 환불 진행됩니다.
                </p>
                <p>제 12 조 (유료서비스 환불정책)</p>
                <p>
                  1. 회사는 회사의 귀책사유로 인한 유료 서비스 환불 시 회원이
                  서비스 이용으로부터 얻은 이익(멤버십 서비스의 경우 이미 이용한
                  일수에 일일 이용 대금을 곱한 금액, 포인트의 경우에는 사용액
                  등)을 공제한 금액을 환불 조치합니다. 2. 회사는 회원의
                  귀책사유로 인한 유료 서비스 환불 시 회원이 서비스 이용으로부터
                  얻은 이익(멤버십 서비스의 경우 이미 이용한 일수에 일일 이용
                  대금을 곱한 금액, 포인트의 경우에는 사용액 등) 및 서비스 결제
                  및 환불로 인해 회사가 부담하게 되는 비용(결제대행수수료,
                  계좌송금수수료 등 제반 수수료)을 공제한 금액을 환불
                  조치합니다. 3. 회사는 환불 진행 중 회원이 신용카드 또는
                  전자화폐 등의 결제수단으로 이용요금을 지불한 경우에는 지체
                  없이 당해 결제수단을 제공한 사업자로 하여금 이용요금의 청구를
                  정지 또는 취소하도록 요청합니다. 다만, 제1항 및 제2항의
                  금액공제가 필요한 경우에는 그러하지 아니할 수 있습니다. 4.
                  아래 각 호에 해당하는 경우 환불이 불가합니다. ① 회사가 발행한
                  쿠폰이나, 이벤트 당첨을 통해 받은 유료서비스 멤버십의 경우 ②
                  기타 회원이 직접 결제하지 않은 경우 ③ 멤버십 결제 후
                  사용내역이 있거나 결제에 따른 추가 지급 혜택을 이용했을 경우 ④
                  제11조 애니플러스 포인트 환불 규정에 어긋나는 경우 5. 기
                  결제된 결제금액 또는 결제취소가 불가능한 결제금액의 환불 신청
                  시에는 해당 요금의 정상납입 확인 후 환불조치가 가능하며,
                  결제취소기간 내 환불 의사를 밝힌 경우에는 결제취소처리를
                  우선적으로 고려하여 처리할 수 있습니다. 6. 환불 받을 금융기관
                  계좌의 예금주 명의와 회사에 등록된 회원 ID의 명의가 동일한
                  경우에만 환불액을 입금하여 드리며, 실제 환불액이
                  입금되기까지는 최대 2주 정도 소요됩니다. (해외금융기관의
                  계좌로는 환불이 불가능합니다.) 7. 개인정보 도용 및 결제정보
                  도용 또는 부정결제 등으로 인한 경우에는 환불되지 않으며, 해당
                  경우의 결제자 개인정보 요구 및 확인은 관계법령에 근거한
                  수사기관의 정당한 요청을 통해서만 확인이 가능합니다. 8. 환불
                  입금은 환불 신청이 접수된 날로부터 2주 이내에 완료되는 것을
                  원칙으로 합니다. 9. 환불 시에는 실제 회원이 결제한 금액에 대해
                  납부영수증 등으로 이용요금의 납부여부를 확인한 후 환불해드리게
                  됩니다. 이용요금의 납부여부의 확인이 불가능한 경우 환불이
                  불가능할 수 있으니 결제와 관련된 납부영수증 등의 증빙자료
                  보관에 유념하시기 바랍니다. 10. 회원탈퇴 및 환불요청 시
                  회원님의 오기(誤記)등의 귀책사유로 인해 발생하는 불이익에
                  대해서 회사는 책임을 지지 않습니다.
                </p>
                <p>제 13 조 (콘텐츠 하자 등에 의한 이용자 피해보상)</p>
                <p>
                  회사는 유료서비스 하자 등에 의한 이용자피해보상의
                  기준•범위•방법 및 절차에 관한 사항을 디지털 콘텐츠 이용자
                  보호지침에 따라 처리합니다.
                </p>
                <p>제 14 조 (상품의 배송)</p>
                <p>
                  1. 배송 소요기간은 입금확인일 익일을 기산일로 하여 배송완료
                  되기까지의 기간을 말합니다. 공휴일 및 기타 휴무일 또는
                  천재지변 등 불가항력적인 사유가 발생한 경우 그 해당기간은 배송
                  소요기간에서 제외됩니다. 2. 배송과 관련하여 회원, 배송업체,
                  금융기관 등과의 사이에 분쟁 등이 발생한 경우에는 해당
                  당사자간에 해결을 원칙으로 하고, 회사는 이에 대하여 관여하지
                  않으며 어떠한 책임도 부담하지 않습니다.
                </p>
                <p>제 15 조 (상품의 반품/교환/취소/환불)</p>
                <p>
                  1. 회원은 구매한 상품에 대해 상품을 받은 날로부터 7일 이내, 각
                  호의 경우 교환/반품 신청을 할 수 있습니다. 단 배송중인
                  경우에는 취소가 아닌 반품 절차에 따라 처리됩니다. ① 상품
                  본체에 명백한 하자가 있는 경우 ② 배송 중에 상품이 파손, 손상된
                  경우 ③ 주문하신 상품과 다른 상품이 배송되었거나 결실이 발생한
                  경우 2. 회원이 구매한 상품에 대해 상품을 받은 날로부터 7일
                  이내, 단순변심에 의해 반품 및 환불을 신청한 경우, 상품 및
                  결제수단에 따라 제반비용(결제대행수수료, 송금수수료 등 각종
                  수수료) 보전을 위한 소정의 위약금이 부과할 수 있습니다. 3.
                  회원이 예약 상품에 대해 예약구매를 취소할 경우
                  제반비용(결제대행수수료, 송금수수료 등 각종 수수료) 보전을
                  위한 소정의 위약금이 부과할 수 있습니다. 4. 일반적으로 반품에
                  소요되는 비용은 반품에 대한 귀책사유가 있는 자에게 귀속됩니다.
                  즉 회원의 단순변심인 경우는 회원이 반품비용을 부담하며, 상품의
                  하자로 인한 반품의 경우는 회사가 해당비용을 부담합니다. 반품에
                  소요되는 비용을 회원이 부담하여야 하는 경우 반품에 소요되는
                  비용의 추가 결제가 이루어지지 않으면 환불이 지연될 수
                  있습니다. 5. 본 조에 따른 반품 신청 시 회사에서 제공하는
                  반송서비스를 이용하지 않거나 반품사유에 관하여 회사에게 정확히
                  통보하지 않을 시 반품처리 및 환불이 지연될 수 있습니다. 6.
                  회원이 상품에 대하여 교환신청을 하더라도 회사에게 교환할
                  상품의 재고가 없는 경우에는 교환이 불가능하며, 이 경우 해당
                  교환신청은 반품으로 처리될 수 있습니다. 7. 결제대금의 환불은
                  회원이 상품을 이상 없이 반품한 날 또는 구매계약을 취소한
                  날로부터 2주 이내에 대금의 결제와 동일한 방법(신용카드, 휴대폰
                  결제취소 등)으로 이루어집니다. 8. 신용카드나 휴대폰을 통한
                  결제대금 환불 시 결제수단의 전자결제대행사업자, 전자결제대행
                  또는 중개서비스 사업자의 정책 상 특정기간이 지나 동일한
                  결제수단의 취소가 불가능한 경우에는 계좌로 환불이 진행됩니다.
                  9. 계좌에 의한 환불은 회원이 상품을 이상 없이 반품한 날 또는
                  구매계약을 취소한 날로부터 2주 이내에 회원이 지정하는 계좌로
                  직접 환불처리 됩니다. 10. 환불 받을 금융기관 계좌의 예금주
                  명의와 회사에 등록된 회원 ID의 명의가 동일한 경우에만 환불액을
                  입금하여 드리며, 실제 환불액이 입금되기까지는 최대 2주 정도
                  소요됩니다. (해외금융기관의 계좌로는 환불이 불가능합니다.) 11.
                  회원은 다음 각 호의 경우에는 환불 또는 상품교환을 요청할 수
                  없습니다. ① 회원의 귀책사유로 인하여 상품이 멸실•훼손된 경우 ②
                  회원의 상품 사용 또는 일부 소비에 의하여 상품의 가치가 현저히
                  감소한 경우 ③ 시간의 경과에 의하여 재판매가 곤란할 정도로
                  상품의 가치가 현저히 감소한 경우 ④ 복제가 가능한 상품의 포장을
                  훼손한 경우 ⑤ 환불 또는 교환을 인정하는 경우 회사에게 회복할
                  수 없는 중대한 피해가 예상되는 경우 ⑥ 배송 완료 후 8일이
                  경과한 경우 ⑦ 구매자가 소유한 기기상의 문제, 호환성 문제로
                  작동이 불가능한 경우
                </p>
                <p>제 16 조 (분쟁의 해결)</p>
                <p>
                  회사는 분쟁이 발생하였을 경우에 회원이 제기하는 정당한
                  의견이나 불만을 반영하여 적절하고 신속한 조치를 취합니다.
                  다만, 신속한 처리가 곤란한 경우에 회사는 회원에게 그 사유와
                  처리일정을 통보합니다.
                </p>
                <p>제 17 조 (준거법 및 관할법원)</p>
                <p>
                  1. 회사와 회원간에 제기된 소송에 대해서는 대한민국 법률을
                  준거법으로 합니다. 2. 회사와 회원간 발생한 분쟁에 관한 소송은
                  제소 당시의 회원의 주소에 의하고, 주소가 없는 경우 거소를
                  관할하는 지방법원의 전속관할로 합니다. 단, 제소 당시 회원의
                  주소 또는 거소가 명확하지 아니한 경우의 관할법원은
                  민사소송법에 따라 정합니다.
                </p>
                <p>부칙</p>
                <p>• (시행일) 이 약관은 2020년 09월 28일부터 시행합니다.</p>
              </div>
            </>
          ) : (
            <>
              <h3>개인정보 처리방침</h3>
              <div className="terms_style">
                <p>1. 총칙</p>
                <p>제 1 조 목적</p>
                <p>
                  주식회사 애니플러스는(이하 ‘회사’라고 합니다)
                  VOD(www.aniplustv.com), 쇼핑(shop.aniplustv.com) 관련 제반
                  서비스(이하 “서비스”라고 합니다)를 이용하는 회원의 개인정보
                  보호를 소중하게 생각하고, 회원의 개인정보를 보호하기 위하여
                  항상 최선을 다해 노력하고 있습니다.
                  <br />
                  <br />
                  회사는 개인정보 보호 관련 주요 법률인 개인정보 보호법,
                  정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하
                  “정보통신망법”이라고 합니다)을 비롯한 모든 개인정보 보호에
                  관련 법률 규정 및 국가기관 등이 제정한 고시, 훈령, 지침 등을
                  준수합니다.
                  <br />
                  <br />본 개인정보처리방침은 회사의 서비스를 이용하는 회원에
                  대하여 적용되며, 회원이 제공하는 개인정보가 어떠한 용도와
                  방식으로 이용되고 있으며, 개인정보 보호를 위하여 회사가 어떠한
                  조치를 취하고 있는지 알립니다. 또한 개인정보와 관련하여 회사와
                  회원간의 권리 및 의무 관계를 규정하여 회원의
                  ‘개인정보자기결정권’을 보장하는 수단이 됩니다.
                </p>

                <p>2. 개인정보의 처리</p>
                <p>제 2 조 개인정보의 수집·이용에 대한 동의</p>
                <p>
                  회사는 적법하고 공정한 방법에 의하여 서비스 이용계약의 성립 및
                  이행에 필요한 최소한의 개인정보를 수집하며 이용자의 개인
                  식별이 가능한 개인정보를 수집하기 위하여 회원가입시
                  개인정보수집·이용 동의에 대한 내용을 제공하고 회원이 '동의'
                  버튼을 클릭하면 개인정보 수집·이용에 대해 동의한 것으로
                  봅니다.
                </p>
                <p>제 3조 수집하는 개인정보의 항목범위 및 수집 방법</p>
                <p>
                  1항. 회원가입, 상담, 서비스 신청 등 서비스 제공 및 계약이행을
                  위해 회원가입 시점에 회사가 회원으로부터 수집하는 개인정보는
                  아래와 같습니다.
                  <br />
                  1) 아이디, 비밀번호, 이메일, 이름, 생년월일, 연령, 성별,
                  휴대폰 번호, 가입IP 연계정보(CI), 중복확인정보(DI), 를
                  수집하며 만약 회원의 생년월일이 만14세 미만 아동일 경우에는
                  법정대리인 정보(법정대리인의 이름, 생년월일, 성별,
                  연계정보(CI), 중복가입확인정보(DI), 휴대전화번호)를 추가로
                  수집합니다.
                  <br />
                  <br />
                  2항. 서비스 이용 과정에서 이용자로부터 수집하는 개인정보는
                  아래와 같습니다.
                  <br />
                  1) 회사는 회원이 유료 서비스를 이용하고자 하는 경우 결제
                  시점에 아래와 같이 결제에 필요한 정보를 수집할 수 있습니다.
                  <br />
                  - 결제수단 소유자 정보(이름), 카드정보, 휴대전화번호,
                  유선전화번호, 결제건별 발행되는 거래 ID, 결제상품코드, 배송지
                  주소
                  <br />
                  2) 회사는 회원이 이벤트, 프로모션에 참여하는 경우 아래의
                  정보를 수집할 수 있습니다.
                  <br />
                  - 이름, 이메일 주소, 휴대전화번호, 주소, 생년월일
                  <br />
                  3) 연령에 따른 콘텐츠 및 상품의 이용/구매 제한, 서비스 부정
                  이용 방지를 위해 본인인증이 진행되며 이름, 생년월일, 성별,
                  내/외국인 여부, 휴대전화번호, 연계정보(CI), 중복확인정보(DI)를
                  수집할 수 있습니다.
                  <br />
                  4) 현금 환불 시 예금주명, 계좌은행명, 계좌번호,
                  관계증명서류(필요 시)를 수집할 수 있습니다.
                  <br />
                  5) 고객센터로 문의 시 정확한 안내를 위해 이메일 주소,
                  휴대전화번호, 이름, 생년월일, 결제정보 등의 정보를 수집할 수
                  있습니다.
                  <br />
                  6) 회원 대상 맞춤형 추천 서비스 제공을 목적으로 이용자를
                  특정할 수 없는 이용한 서비스의 정보, 접속시간 및 빈도 등의
                  행태 정보를 수집할 수 있습니다.
                  <br />
                  <br />
                  3항. 서비스 이용과정에서 아래와 같은 정보들이 생성되어 수집될
                  수 있습니다.
                  <br />
                  1) PC : PC 사양정보, 브라우저 정보, 기타 서비스 이용 시
                  사용되는 프로그램 버전 정보
                  <br />
                  2) 휴대전화(스마트폰) & 스마트OS 탑재 모바일 기기(Tablet PC
                  등) : 모델명, OS정보, 이동통신사
                  <br />
                  3) 기타 정보 : 서비스 이용(정지) 기록, 접속 로그, 쿠키, 접속
                  IP정보
                  <br />
                  <br />
                  4항. 회사는 다음과 같은 방식으로 개인정보를 수집합니다.
                  <br />
                  1) 회원가입 및 서비스 이용 과정에서 이용자가 개인정보 수집에
                  대해 동의를 하고 직접 정보를 입력하는 경우 개인정보를
                  수집합니다.
                  <br />
                  2) 온라인, 오프라인에서 진행되는 이벤트 등을 통해 개인정보가
                  수집될 수 있습니다.
                  <br />
                  3) 제휴 회사로부터의 제공을 통해 개인정보가 수집될 수
                  있습니다.
                  <br />
                  4) 고객센터를 통한 상담 과정에서 웹페이지, 메일, 팩스, 전화
                  등을 통해 개인정보가 수집될 수 있습니다.
                  <br />
                  5) 기기정보와 같은 생성정보는 PC웹, 모바일 웹/앱 이용 과정에서
                  자동으로 생성되어 수집될 수 있습니다.
                  <br />
                  <br />
                  4항. 회사는 기본적 인권침해의 우려가 있는 개인정보(인종 및
                  민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록,
                  건강상태 및 성생활 등)를 요구하지 않으며, 위의 항목 이외에
                  다른 어떠한 목적으로도 수집, 사용하지 않습니다.
                  <br />
                  <p>
                    제 3 조 개인정보의 자동 수집 장치의 설치, 운영 및 그 거부에
                    관한 사항
                  </p>
                  <p>
                    1항. 쿠키란 웹 서버가 웹 브라우저에 보내어 저장했다가 서버의
                    부가적인 요청이 있을 때 다시 서버로 보내주는 문자열
                    정보(텍스트 파일)로 회원의 컴퓨터 하드디스크에 저장되며 쿠키
                    (cookie)에는 사용한 웹사이트의 정보 및 이용자의 개인정보가
                    담길 수 있습니다.
                    <br />
                    1) 회사에서 운영하는 서비스는 인터넷을 통하여 회원의 정보를
                    저장하고 수시로 찾아내는 쿠키(cookie)를 설치, 운용하고
                    있습니다. 회원이 웹사이트에 접속을 하면 회원의 브라우저에
                    있는 쿠키의 내용을 읽고, 추가정보를 찾아 접속에 따른 성명
                    등의 추가 입력 없이 서비스를 제공할 수 있습니다.
                    <br />
                    2) 회원은 쿠키 설치에 대한 선택권을 가지고 있으며 회원은
                    웹브라우저에서 옵션을 설정함으로서 모든 쿠키를 허용하거나,
                    또는 쿠키가 저장될 때마다 확인을 거치거나, 혹은 모든 쿠키의
                    저장을 거부할 수도 있습니다. 다만, 회원이 쿠키 설치를
                    거부하는 경우 서비스 제공에 어려움이 발생할 수도 있습니다.
                    <br />
                    3) 회사가 쿠키를 통해 수집하는 정보는 회원의 ID 서비스
                    이용에 필요한 정보에 한하며, 그 외의 다른 정보는 수집하지
                    않습니다. 회사가 쿠키(cookie)를 통해 수집한 정보는 다음의
                    목적을 위해 사용될 수 있습니다.
                    <br />
                    <br />
                    가. 서비스 이용시 정보주체의 성명, 아이디, 연령 등의 정보
                    확인
                    <br />
                    <br />
                    4) 회원은 쿠키를 언제든지 차단할 수 있습니다.
                    <br />
                    [안드로이드폰] Google 설정 > 광고 > 광고 맞춤설정 선택 또는
                    해제
                    <br />
                    [아이폰] 설정 > 개인정보보호 > 광고 > 광고 추적 제한
                    <br />
                    [PC웹]
                    <br />
                    익스플로러: 도구>인터넷옵션>개인정보>고급 에서 쿠키 설정
                    <br />
                    크롬: 설정>쿠키 및 기타 사이트 데이터 에서 쿠키 설정
                    <br />
                  </p>
                  <p>제 4조 개인정보의 수집목적 및 이용목적</p>
                  <p>
                    1항. 회사는 수집한 개인정보를 다음의 목적으로 활용합니다.
                    <br />
                    1) 서비스 제공에 관한 계약 이행 유료 서비스 제공에 따른
                    요금정산
                    <br />
                    - 콘텐츠 제공, 유료 서비스 이용에 대한 과금, 구매 및 요금
                    결제, 본인인증, 물품배송 또는 청구서 등 발송, 요금 추심
                    <br />
                    2) 회원관리
                    <br />
                    - 회원제 서비스 이용에 따른 본인확인, 개인식별, 불량회원의
                    부정 이용 방지와 비인가 사용 방지, 중복가입확인, 가입의사
                    확인, 연령확인, 만 14세 미만 아동 개인정보 수집 시
                    법정대리인 동의 여부 확인 및 본인확인, 분쟁 조정을 위한
                    기록보존, 불만처리 등 민원처리, 계정 정보 변경 등 고지사항
                    전달
                    <br />
                    3) 마케팅 및 광고에 활용
                    <br />
                    광고 게재, 앱푸시 등의 방법으로 맞춤형 콘텐츠의 추천, 이벤트
                    및 광고성 정보와 참여기회 제공 등을 위하여 접속 빈도, 회원의
                    서비스 이용에 대한 통계 등 개인정보를 이용합니다. 앱푸시의
                    경우 회원은 언제든지 앱푸시 설정을 통하여 이를 거절할 수
                    있습니다.
                    <br />
                    4) 맞춤형 서비스 제공에 활용
                    <br />
                    신규 서비스 개발 및 콘텐츠 추천 등 맞춤형 서비스 제공,
                    서비스 유지·관리 및 품질 향상, 통계학적 특성에 따른 서비스
                    제공 등의 방법으로 맞춤형 콘텐츠를 추천, 서비스 유효성 확인
                    등을 위하여 접속 빈도, 회원의 서비스 이용에 대한 통계 등
                    개인정보를 이용합니다.
                    <br />
                  </p>
                  <p>제 5조 개인정보의 제3자 제공 및 위탁</p>
                  <p>
                    1항. 회사는 회원의 개인정보를 본 개인정보처리방침에서 명시된
                    범위를 초과하여 이용하거나 회원의 동의 없이 본
                    개인정보처리방침에 명시된 제공 대상자 외의 제3자(타인 또는
                    타기 업 기관)에 제공하지 않습니다. 다만, 다음 각호의 어느
                    하나에 해당하는 경우에는 예외로 합니다.
                    <br />
                    1) 관계법령에 의하여 수사, 재판 또는 행정상의 목적으로
                    관계기관으로부터 요구가 있을 경우
                    <br />
                    2) 금융실명거래 및 비밀보장에 관한 법률, 신용정보의 이용 및
                    보호에 관한 법률, 전기통신기본법, 전기통신사업법, 지방세법,
                    소비자보호법, 한국은행법, 형사소송법 등 기타 관계법령에서
                    정한 절차에 따른 요청이 있는 경우
                    <br />
                    <br />
                    2항. 영업의 전부 또는 일부를 양도하거나, 합병/상속 등으로
                    서비스제공자의 권리, 의무를 이전 승계하는 경우 개인 정보보호
                    관련 회원의 권리를 보장하기 위하여 반드시 그 사실을 회원에게
                    통지합니다.
                    <br />
                    <br />
                    3항. 보다 나은 서비스 제공을 위하여 회사가 귀하의 개인정보를
                    타 기업 등 제3자에게 제공하는 것이 필요한 경우 회사는 사전에
                    제휴사가 누구인지, 제공 또는 공유되어야 하는 개인정보항목이
                    무엇인지, 제공 또는 공유되는 개인정보의 이용목적, 그리고
                    언제까지 공유되며 어떻게 보호 관리되는지에 대하여 회원에게
                    고지하여 동의를 구하는 절차를 거칠 것이며, 회원이 동의하지
                    않는 정보는 제3자에 제공하거나 제3자와 공유하지 않습니다.
                    회사는 개인정보처리방침에서 정한 본래의 수집목적 및
                    이용목적에 반하여 무분별하게 회원의 개인 정보가 제공되지
                    않도록 최대한 노력하겠습니다.
                    <br />
                    <br />
                    4항. 회사는 서비스 제공을 위하여 필요한 업무 중 일부를 외부
                    업체에 위탁하고 있으며, 위탁받은 업체가 정보통신망법에 따라
                    개인정보를 안전하게 처리하도록 필요한 사항을 규정하고
                    관리/감독을 하고 있습니다. 회사가 수탁업체에 위탁하는 업무와
                    관련된 서비스를 이용하지 않는 경우, 이용자의 개인정보가
                    수탁업체에 제공되지 않습니다.
                    <br />
                  </p>
                  <p>제 6조 개인정보의 처리 위탁</p>
                  <p>
                    1) 결제 대행
                    <br />
                    - 수탁업체: (주) 토스페이먼츠
                    <br />
                    - 위탁업무 내용: 서비스 계약 이용을 위한 결제 처리 및 결제
                    도용 방지
                    <br />
                    <br />
                    2) 휴대폰을 통한 사용자 본인인증
                    <br />
                    - 수탁업체: (주) 드림시큐리티
                    <br />
                    - 위탁업무 내용: 사용자 본인인증
                    <br />
                    <br />
                    3) 카카오 알림톡
                    <br />
                    - 수탁업체: ㈜ 슈어엠
                    <br />
                    - 위탁업무 내용: 결제 정보 제공, 상영회 좌석 정보 제공,
                    비밀번호 변경 등 계정 상태의 변경 안내
                    <br />
                    <br />
                    4) 데이터 보관 및 시스템 운영
                    <br />
                    - 수탁업체 : ㈜ OFS
                    <br />
                    - 위탁 업무 내용 : 서비스 제공을 위한 데이터 보관 및 시스템
                    운영
                    <br />
                    - 개인정보 항목 : 서비스 제공 과정에서 수집한 모든 개인정보
                    <br />
                    - 개인정보 보유, 이용기간 : 회원 탈퇴 또는 개인정보 유효기간
                    도래 시까지 보관
                    <br />
                  </p>
                  <p>제 7조 회원 및 법정 대리인의 권리와 그 행사방법</p>
                  <p>
                    1항. 회원은 언제든지 자신의 개인정보를 조회, 수정, 삭제할 수
                    있습니다. 만 14세 미만의 아동의 개인정보는 그
                    법정대리인(이하 본 조에서 “법정대리인”이라고 합니다)이
                    아동을 대리하여 위와 같은 권리를 행사할 수 있습니다.
                    <br />
                    <br />
                    2항.회원 및 법정대리인은 제14조에 기재된 고객센터에 웹 문의,
                    서면, 전화, 전자우편의 방법으로 본인(법정대리인의 경우는
                    아동)의 개인정보의 조회, 수정, 삭제를 요청할 수 있습니다.
                    고객센터는 회원 또는 법정대리인의 권리 행사에 대하여 지체
                    없이 조치하고 처리 결과를 안내합니다.
                    <br />
                    <br />
                    3항.회원은 웹, 전용 애플리케이션의 [설정] 메뉴에서 등록되어
                    있는 개인정보를 직접 조회, 수정할 수 있으며, 즉시 결과를
                    확인할 수 있습니다.
                    <br />
                    <br />
                    4항.회원 및 법정대리인이 위 제2, 3항의 조회, 수정, 삭제
                    요청의 처리 결과에 대해 이의가 있을 경우 고객센터에 연락할
                    수 있으며, 회사는 이의제기 내용을 검토하여 처리 결과를
                    안내합니다.
                    <br />
                    <br />
                    5항.회원 또는 만 14세 미만 아동의 법정대리인은 서비스
                    이용계약해지(회원탈퇴)를 통하여 개인정보의 수집 및
                    이용동의에 대한 동의를 철회할 수 있습니다.
                    <br />
                    <br />
                    6항.개인정보의 정정을 요청하신 경우에는 정정을 완료하기
                    전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한
                    잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정
                    처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록
                    하겠습니다. 단, 다음과 같은 경우에는 예외적으로 개인정보의
                    열람 및 정정을 제한할 수 있습니다.
                    <br />
                    1) 본인 또는 제 3 자의 생명, 신체, 재산 또는 권익을 현저하게
                    해할 우려가 있는 경우
                    <br />
                    2) 당해 서비스 제공자의 업무에 현저한 지장을 미칠 우려가
                    있는 경우
                    <br />
                    3) 법령에 위반하는 경우
                    <br />
                    <br />
                    7항. 회사는 삭제 또는 회원 탈퇴 요청이 있을 경우, 개인정보
                    및 개인 데이터를 삭제 또는 제거합니다. 단, 회사는 제9조
                    "개인정보의 보관기간 및 이용기간"에 명시된 바에 같이 법령에
                    따른 기간 동안 회원의 개인정보를 보관할 수 있습니다.
                    <br />
                    <br />
                    8항. 회사는 회원이 타인의 개인정보를 도용하여 회원가입 등을
                    하였음을 알게 된 때 지체 없이 해당 아이디에 대한 서비스
                    이용정지 또는 회원탈퇴 및 개인정보 삭제 등 필요한 조치를
                    취합니다. 또한 자신의 개인정보 도용을 인지한 회원이 해당
                    아이디에 대한 서비스 이용정지 또는 회원탈퇴 및 개인정보
                    삭제를 요구하는 경우에도 회사는 즉시 조치를 취합니다.
                  </p>
                  <p>제 8조 개인정보의 보관기간 및 이용기간</p>
                  <p>
                    1항. 회원의 개인정보는 개인정보의 수집목적 또는 제공받은
                    목적이 달성되면 파기됩니다. 회원이 회원탈퇴를 하거나
                    개인정보 허위기재로 인해 회원 ID 삭제 처분을 받은 경우
                    수집된 개인정보는 완전히 삭제되며 어떠한 용도로도 이용할 수
                    없도록 처리됩니다.
                    <br />
                    <br />
                    2항. 또한 명의 도용 등 분쟁 발생시 본인확인을 위해 제출 받은
                    신분증 사본은 본인확인 후 즉시 파기합니다.
                    <br />
                    <br />
                    3항. 회원의 개인정보는 개인정보의 수집 및 이용목적이
                    달성되면 지체 없이 파기되나, 아래 각 항목에 해당하는
                    경우에는 명시한 기간 동안 보관할 수 있으며, 그 외 다른
                    목적으로는 사용하지 않습니다.
                    <br />
                    <br />
                    1) 불건전한 서비스 이용으로 서비스에 물의를 일으킨 이용자의
                    경우 사법기관 수사의뢰를 하거나 다른 회원을 보호할 목적으로
                    1년간 해당 개인정보를 보관할 수 있습니다.
                    <br />
                    2) 관계법령의 규정에 의하여 보관할 필요가 있는 경우 회사는
                    개인정보 수집 및 이용 목적 달성 후에도 관계법령 에서 정한
                    일정 기간 동안 회원의 개인정보를 보관할 수 있습니다.
                    <br />
                    가. 계약 또는 청약철회 등에 관한 기록: 5년
                    <br />
                    나. 대금결제 및 재화의 공급에 관한 기록: 5년
                    <br />
                    다. 소비자의 불만 또는 분쟁처리에 관한 기록: 3년
                    <br />
                    라. 표시, 광고에 관한 기록: 6개월
                    <br />
                    마. 웹사이트 방문기록: 3개월
                    <br />
                    3) 회사는 ‘개인정보 유효기간제’에 따라 1년간 서비스를
                    이용하지 않은 회원의 개인정보를 별도로 분리 보관하여
                    관리합니다.
                    <br />
                  </p>
                  <p>제 9조 개인정보의 파기절차 및 방법</p>
                  <p>
                    회사는 수집한 개인정보의 이용목적이 달성된 후 별도의 DB로
                    옮겨 보관기간 및 이용기간에 따라 해당 정보를 지체 없이
                    파기합니다. 파기절차 및 방법은 다음과 같습니다.
                    <br />
                    <br />
                    1항. 파기절차
                    <br />
                    회원이 서비스 가입 등을 위해 기재한 개인정보는 서비스 해지
                    등 이용목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한
                    정보보호 사유에 따라 일정기간(개인정보 보관기간 및 이용기간
                    참조) 동안 저장 보관된 후 삭제하거나 파기합니다.
                    <br />
                    <br />
                    2항. 파기방법
                    <br />
                    서면양식에 기재하거나, 종이에 출력된 개인정보는 분쇄기로
                    분쇄하여 파기하고, 전자적 파일형태로 저장된 개인 정보는
                    기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
                    <br />
                    <br />
                  </p>
                  <p>제 10조 회원의 권리와 의무</p>
                  <p>
                    회원은 본인의 개인정보를 최신의 상태로 정확하게 입력하여
                    불의의 사고를 예방해주시기 바랍니다. 회원이 입력한 부정확한
                    정보로 인해 발생하는 사고의 책임은 회원 자신에게 있으며 타인
                    정보의 도용 등 허위정보를 입력할 경우 계정의 이용이 제한될
                    수 있습니다.
                    <br />
                    회사가 운영하는 서비스를 이용하는 회원은 개인정보를 보호받을
                    권리와 함께 스스로를 보호하고 타인의 정보를 침해하지 않을
                    의무도 가지고 있습니다. 회원은 아이디(ID), 비밀번호를 포함한
                    개인정보가 유출되지 않도록 조심하여야 하며, 게시물을 포함한
                    타인의 개인정보를 훼손하지 않도록 유의해야 합니다. 만약 이
                    같은 책임을 다하지 못하고 타인의 정보 및 타인의 존엄성을
                    훼손할 경우에는 정보통신망법 등에 의해 처벌 받을 수
                    있습니다.
                    <br />
                  </p>
                  <p>제 11조 고지의 의무</p>
                  <p>
                    현 「개인정보처리방침」 내용의 추가, 삭제 및 수정이 있을
                    시에는 개정 최소 7일 전부터 홈페이지의 '공지사항'을 통해
                    고지하고, 개정 내용이 회원에게 불리할 경우에는 개정
                    30일전부터 고지할 것입니다. 변경 관련 문의는 고객센터를 통해
                    할 수 있습니다.
                  </p>
                  <p>제 12조 개인정보보호책임자 및 담당자</p>
                  <p>
                    회사는 회원의 개인정보보호를 가장 중요시하며, 회원의
                    개인정보가 훼손, 침해 또는 누설되지 않도록 최선을 다하고
                    있습니다. 서비스를 이용하시면서 발생하는 모든 개인정보보호
                    관련 민원은 고객센터에 신고하시면 신속하게 답변해 드리도록
                    하겠습니다.
                    <br />
                    [개인정보보호책임자]
                    <br />
                    성 명: 손혜환
                    <br />
                    소 속: 플랫폼개발팀
                    <br />
                    전자우편: hhson@aniplustv.com
                    <br />
                    <br />
                    [개인정보관리담당자]
                    <br />
                    성 명: 손혜환
                    <br />
                    소 속: 플랫폼개발팀
                    <br />
                    전자우편: hhson@aniplustv.com
                    <br />
                  </p>
                  <p>제 13조 개인정보 침해 관련 상담 및 신고</p>
                  <p>
                    회사는 회원의 의견을 소중하게 생각합니다.
                    <br />
                    회사가 운영중인 서비스에 대하여 문의사항이 있을 경우
                    고객센터 등에 문의하시면 신속/정확한 답변을 드리겠습니다.
                    회사는 원활환 의사소통을 위해 고객상담센터를 운영하고 있으며
                    연락처는 다음과 같습니다.
                    <br />
                    <br />
                    [고객상담센터]
                    <br />
                    - 전화번호: 070-7126-7013
                    <br />
                    - 팩스번호: 02-568-7022
                    <br />
                    - 전자우편: webmaster@aniplustv.com
                    <br />
                    - 웹문의: https://www.aniplustv.com
                    <br />
                    - 주소: 서울특별시 영등포구 국제금융로 10 Three IFC 28층
                    고객센터
                    <br />
                    <br />
                    기타 개인정보에 관한 상담이 필요한 경우에는 정보통신부 산하
                    공공기관인 한국인터넷진흥원(KISA) 개인정보침해신고센터,
                    경찰청 사이버테러대응센터, 대검찰청 사이버범죄수사단으로
                    문의하시기 바랍니다.
                    <br />
                    <br />
                    [한국인터넷진흥원 개인정보침해신고센터]
                    <br />
                    전화번호 : 국번없이 118
                    <br />
                    <br />
                    링크 사이트
                    <br />
                    회사는 운영중인 서비스 홈페이지를 통하여 회원에게 다른
                    회사의 웹사이트 또는 자료에 대한 링크를 제공할 수 있습니다.
                    이 경우 해당 사이트의 「개인정보처리방침」은 회사가 운영중인
                    서비스의 「개인정보처리방침」과 무관하므로 새로 방문한
                    사이트의 「개인정보처리방침」을 확인하시기 바랍니다.
                  </p>
                  <p>제 14조 청소년보호정책</p>
                  <p>
                    회사는 각종 청소년 유해정보로부터 청소년을 보호하고자 관련
                    법률에 따라 만 19세 미만의 청소년들이 유해정보에 접근할 수
                    없도록 청소년보정책을 마련하고 시행하고 있습니다. 회사는
                    또한 청소년의 건전한 성장을 저해하는 음란, 불법 등의
                    유해정보와 비윤리적, 반사회적 행위에 대해서는 엄격하게
                    제재하기 위하여 다음과 같이 활동하고 있습니다.
                    <br />
                    <br />
                    - 청소년유해정보로부터의 청소년보호계회읙 수립
                    <br />
                    - 청소년유해정보에 대한 청소년접근제한 및 관리조치
                    <br />
                    - 정보통신업무 종사자에 대한 청소년유해정보로부터의
                    청소년보호를 위한 교육
                    <br />
                    - 청소년유해정볼 인해 피해상담 및 고충처리
                    <br />
                    - 그 밖에 청소년유해정보로부터 청소년을 보호하기 위하여
                    필요한 사항
                    <br />
                    - 아동청소년이용음란물로 의심되는 콘텐츠에 대한 신고 접수
                    <br /> <br />
                    [청소년보호 책임자]
                    <br />
                    성명: 손혜환
                    <br />
                    부서: IT개발팀
                    <br />
                    이메일: hhson@aniplustv.com
                    <br /> <br />
                    [청소년보호 담당자]
                    <br />
                    성명: 손혜환
                    <br />
                    부서: IT개발팀
                    <br />
                    이메일: hhson@aniplustv.com
                    <br />
                  </p>
                  <p>본 방침은 2023년 03월 01일부터 적용됩니다.</p>
                </p>
              </div>
            </>
          )}
        </div>

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(CustomerUse));
